import { TierField } from './hooks/useTiers';
import { AGGREGATE_ONLY, EMBEDDED_ONLY } from './ProcessingRuleModal.constants';

export const isLastOrOnlyTier = (index: number, total: number) => index === total - 1 || total <= 1;

export const buildTierTriggerIds = (
  item: TierField,
  index: number,
  total: number,
  processingRuleType?: string
): number[] => {
  const ids: number[] = [];
  if (isLastOrOnlyTier(index, total)) return ids;

  if (processingRuleType !== EMBEDDED_ONLY && item.aggregateTrigger) {
    ids.push(Number(item.aggregateTrigger));
  }
  if (processingRuleType !== AGGREGATE_ONLY && item.embeddedTrigger) {
    ids.push(Number(item.embeddedTrigger));
  }
  return ids;
};

export const hasInvalidTriggers = (tiers: TierField[], processingRuleType?: string): boolean =>
  tiers.some((item, index) => {
    if (isLastOrOnlyTier(index, tiers.length)) return false;
    if (processingRuleType !== EMBEDDED_ONLY && !item.aggregateTrigger) return true;
    if (processingRuleType === EMBEDDED_ONLY && !item.embeddedTrigger) return true;
    return false;
  });
